export default {
    it: 'Italiano',
    en: 'English'
}